class RsMobileNavColumns extends HTMLElement {
  connectedCallback() {
    this._parents = this.querySelectorAll('[data-parent-index]');
    this._panels = this.querySelectorAll('[data-panel-index]');

    this._parents.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.dataset.href) {
          window.location.href = btn.dataset.href;
          return;
        }
        this._activateParent(btn.dataset.parentIndex);
      });
    });

    this.querySelectorAll('.rs-mobile-nav-columns__group-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.rs-mobile-nav-columns__group').classList.toggle('is-open');
      });
    });

    // Reset to first parent and collapse all groups when drawer opens
    const drawer = this.closest('header-drawer');
    if (drawer) {
      const observer = new MutationObserver(() => {
        if (drawer.classList.contains('is-open')) {
          this._activateParent('0');
          this.querySelectorAll('.rs-mobile-nav-columns__group').forEach(g => g.classList.remove('is-open'));
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  _activateParent(index) {
    const idx = String(index);
    this._parents.forEach(p => p.classList.toggle('is-active', p.dataset.parentIndex === idx));
    this._panels.forEach(p => p.classList.toggle('is-active', p.dataset.panelIndex === idx));
  }
}

if (!customElements.get('rs-mobile-nav-columns')) {
  customElements.define('rs-mobile-nav-columns', RsMobileNavColumns);
}
